import React from "react";
import "./GoalCard.css";
import BBSButton from "../../ui/BBSButton"; 
import { Bullseye as Target } from "react-bootstrap-icons";

const GoalCard = ({ data, onClick }) => {
  // Tastatur-Unterstützung: Enter-Taste löst Klick aus
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  // Dynamisches Aria-Label bauen, um das Badge barrierefrei einzubeziehen
  const ariaLabelText = `${data.badgeText ? `Hinweis: ${data.badgeText}. ` : ''}${data.label}: ${data.subLabel || ''}. Mehr erfahren.`;

  return (
    <div 
      className="card w-100 border-0 shadow-sm custom-saas-card"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      tabIndex="0" // Macht die Karte per Tab-Taste erreichbar
      role="button" // Signalisiert: Das ist ein interaktives Element
      aria-label={ariaLabelText}
      style={{ 
        cursor: "pointer", 
        borderRadius: "16px", 
        overflow: "hidden", 
        position: "relative" // WICHTIG: Bezugspunkt für das absolute Badge
      }}
    >
      {/* EYE-CATCHER / BADGE */}
      {data.badgeText && (
        <div className="goal-card-corner-ribbon">
          {data.badgeText}
        </div>
      )}

      {/* Padding oben leicht erhöht (pt-5 statt p-4 gesamt), falls das Badge sonst den Titel überlagert */}
      <div className="card-body p-4 pt-5 d-flex flex-column">
        <h3
          className="h5 fw-bold mb-2 pb-3 text-green-bbs border-bottom"
          style={{ 
            letterSpacing: "-0.01em",
            minHeight: "4.5em",
            display: "flex",
            alignItems: "center"
          }}
        >
          {data.label}
        </h3>

        {data.subLabel && (
          <div 
          className="text-green-bbs-dark fw-semibold mb-3 small">
            {data.subLabel}
          </div>
        )}

        <p
          className="card-text mb-3 text-gray-bbs"
          style={{
            fontSize: "0.95rem",
            lineHeight: "1.6",
            textAlign: "left", 
            minHeight: "130px",
          }}
        >
          {data.fokus}
        </p>

        <div className="mt-auto pt-3 border-top">
          <span
            className="text-uppercase fw-bold pb-1 d-block text-green-bbs"
            style={{ fontSize: "0.9rem", letterSpacing: "0.05em" }}
          >
            <Target size={18} className="me-2" aria-hidden="true" />
            Zielgruppe
          </span>
          <span className="text-gray-bbs small">
            {data.zielgruppe}
          </span>
        </div>

        <div className="mt-4">
          <BBSButton 
            variant="green" 
            className="w-100"
            tabIndex="-1" 
            aria-hidden="true"
          >
            Mehr erfahren
          </BBSButton>
        </div>
      </div>
    </div>
  );
};

export default GoalCard;